class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.subscriptionWrapper = this.querySelector('.rtx-subscription')
    this.rtxSelect = this.subscriptionWrapper.querySelector('[name="rtx_selling_plan"]')
    this.sellingPlan = this.subscriptionWrapper.querySelector('[name="selling_plan"]')
    this.form = this.querySelector('form')

    this.subscriptionWrapper.addEventListener('change', this.handleSubscriptionChange.bind(this))
    this.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubscriptionChange(e) {
    const value = e.target.value
    this.sellingPlan.value = value === 'purchaseTypeOneTime' ? '' : this.rtxSelect.value
  }

  handleSubmit(e) {
    e.preventDefault()
  }
}

customElements.define('product-form', ProductForm);
